export default "__VITE_ASSET__CR2eiqV0__"